// @ts-nocheck
import useAppDispatch from "@insite/client-framework/Common/Hooks/useAppDispatch";
import translate from "@insite/client-framework/Translate";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import constants from "@store/constants";
import applyDraftParameter from "@store/Framework/Store/Greif/Pages/TrailerTrackingV2/Handlers/ApplyDraftParameter";
import cancelDraftParameterChanges from "@store/Framework/Store/Greif/Pages/TrailerTrackingV2/Handlers/CancelDraftParameterChanges";
import clearDraftParameter from "@store/Framework/Store/Greif/Pages/TrailerTrackingV2/Handlers/ClearDraftParameter";
import {
    useTrailerTrackingV2DataView,
    useTrailerTrackingV2State,
} from "@store/Framework/Store/Greif/Pages/TrailerTrackingV2/TrailerTrackingV2Hooks";
import FilterDrawerAndButton, {
    FilterDrawerAndButtonPresentationProps,
} from "@store/Library/Components/FilterDrawerAndButton";
import Heading, { HeadingPresentationProps } from "@store/Library/Components/Toolkit/Heading";
import TrailerTrackingV2FilterFieldBillingType from "@store/Library/Components/TrailerTrackingV2/TrailerTrackingV2FilterFieldBillingType";
import TrailerTrackingV2FilterFieldDwellTime from "@store/Library/Components/TrailerTrackingV2/TrailerTrackingV2FilterFieldDwellTime";
import TrailerTrackingV2FilterFieldLocations from "@store/Library/Components/TrailerTrackingV2/TrailerTrackingV2FilterFieldLocations";
import TrailerTrackingV2FilterFieldPlant from "@store/Library/Components/TrailerTrackingV2/TrailerTrackingV2FilterFieldPlant";
import TrailerTrackingV2FilterFieldPoNumber from "@store/Library/Components/TrailerTrackingV2/TrailerTrackingV2FilterFieldPoNumber";
import TrailerTrackingV2FilterFieldShipTo from "@store/Library/Components/TrailerTrackingV2/TrailerTrackingV2FilterFieldShipTo";
import TrailerTrackingV2FilterFieldTrailerId from "@store/Library/Components/TrailerTrackingV2/TrailerTrackingV2FilterFieldTrailerId";
import React, { FC } from "react";

export interface TrailerTrackingHeaderProps extends WidgetProps {}

export interface TrailerTrackingHeaderStyles {
    heading?: HeadingPresentationProps;
    filterDrawerAndButton?: FilterDrawerAndButtonPresentationProps;
}

export const trailerTrackingHeaderStyles: TrailerTrackingHeaderStyles = {
    heading: {
        variant: "h1",
    },
};

const styles = trailerTrackingHeaderStyles;

const TrailerTrackingHeader: FC<TrailerTrackingHeaderProps> = () => {
    const dispatch = useAppDispatch();
    const { isLoading } = useTrailerTrackingV2DataView();
    const { canApplyFilters, canClearFilters, filterCount } = useTrailerTrackingV2State();

    return (
        <Heading {...styles.heading} usePageTitle={true}>
            <FilterDrawerAndButton
                {...styles.filterDrawerAndButton}
                filterCount={filterCount}
                filterButtonProps={{
                    disabled: isLoading,
                }}
                drawerProps={{
                    handleClose: () => dispatch(cancelDraftParameterChanges()),
                    headline: translate("Filter Trailer Reports"),
                }}
                applyButtonProps={{
                    disabled: !canApplyFilters,
                    onClick: () => dispatch(applyDraftParameter()),
                }}
                clearButtonProps={{
                    disabled: !canClearFilters,
                    onClick: () => dispatch(clearDraftParameter()),
                }}
            >
                <TrailerTrackingV2FilterFieldLocations />
                <TrailerTrackingV2FilterFieldShipTo />
                <TrailerTrackingV2FilterFieldPoNumber />
                <TrailerTrackingV2FilterFieldTrailerId />
                <TrailerTrackingV2FilterFieldDwellTime />
                <TrailerTrackingV2FilterFieldBillingType />
                <TrailerTrackingV2FilterFieldPlant />
            </FilterDrawerAndButton>
        </Heading>
    );
};

const widgetModule: WidgetModule = {
    component: TrailerTrackingHeader,
    definition: {
        displayName: "Header (V2)",
        group: constants.widgetGroup.trailerTracking,
        allowedContexts: [constants.pageType.trailerTracking],
    },
};

export default widgetModule;
